module.exports = {
    getStaticAssetsPathPrefix: function (platformEnv) {
        return platformEnv === 'true' ? '/plat_static/platform/pc/' : '/static/platform/pc/';
    }
};
